import { BaseStateMiddleware, IActivityHandler, IMiddlewareConfig } from 'smarthub-common'
import {
  ActivityCollection as Collection,  
  createActivityMiddleware as createMiddleware,
} from 'smarthub-core'
import {
  coreActivityMiddleware as core,
} from 'smarthub-components'

export const activityMiddleware = (): IMiddlewareConfig<BaseStateMiddleware, IActivityHandler> => {
  const collection = new Collection()
  const middleware = createMiddleware(core, collection.middleware)
  return {
    middleware,
    collection,
  }
}
